module.exports = __webpack_public_path__ + "static/media/Repeat Offender.9c6e8550.jpg";